export default function resetDealNotifications(_ref) {
  let {
    types
  } = _ref;
  return () => (dispatch, getState) => {
    const allDealDetails = getState()?.payments?.dealDetails;
    const resetFlagNotifications = deals => Object.keys(deals).reduce((acc, key) => {
      const dealDetails = allDealDetails[key];
      const {
        vehicle,
        deal,
        creditApp
      } = dealDetails;
      const updatedVehicle = {
        ...vehicle,
        priceChangeFlag: false,
        sellingVehicleChangeFlag: false
      };
      const updatedDeal = {
        ...deal,
        dealTypeChangeFlag: false,
        paymentChangeFlag: false
      };
      const updatedCreditApp = {
        ...creditApp,
        isDecisionChanged: false
      };
      acc[key] = {
        ...dealDetails,
        vehicle: updatedVehicle,
        deal: updatedDeal,
        creditApp: updatedCreditApp
      };
      return acc;
    }, {});
    const deals = resetFlagNotifications(allDealDetails);
    dispatch({
      type: types.SET_DEAL_DETAILS,
      payload: {
        ...deals
      }
    });
    dispatch({
      type: types.RESET_DEAL_NOTIFICATIONS
    });
  };
}